export const getBudgets = ( state ) => {
    return state.budgets
}

export const getTeacher = ( state ) => {
    return state.teachers
}

export const getProjects = ( state ) => {
    return state.projects
}